import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCurrentDateDDMMYYYY } from "./utils/getCurrentDate";
import {
  addNewDocTransmittal,
  getAllDocTransmittalsProject,
  getCompanyCustomers,
  getCompanyVendors,
  getProject,
} from "./api";
import DocTransmittalRegister from "./DocTransmittalRegister";
import { useDCS } from "../Table/DCSContext";
const date = getCurrentDateDDMMYYYY();

export const DocTransmittalContext = createContext();
export const useDocTransmittalContext = () => useContext(DocTransmittalContext);

export const AuthContextProvider = ({ children }) => {
  const { plantId } = useParams();
  console.log("plantId", plantId);

  const { selectedDocuments } = useDCS();
  console.log("selectedDocuments from tansmittal tab", selectedDocuments);

  const initialState = {
    number: "",
    rev: 0,
    receiver: { id: "", name: "", email: "" },
    receiverType: "Client",
    vendor: undefined,
    customer: undefined,
    project: { id: plantId, rev: 0 },
    date,
  };

  const [allDocTransmittals, setAllDocTransmittals] = useState([]);
  const [newDoc, setNewDoc] = useState(initialState);
  const [files, setFiles] = useState([]);
  const [tab, setTab] = useState("form");
  const [vendors, setVendors] = useState([]);
  const [clients, setClients] = useState([]);

  const [openDocTransmittalRegister, setOpenDocTransmittalRegister] =
    useState(false);
  const handleOpenDocTransmittalRegister = () =>
    setOpenDocTransmittalRegister(true);
  const handleCloseDocTransmittalRegister = () =>
    setOpenDocTransmittalRegister(false);

  console.log(newDoc);

  const getClientsAndVendors = async () => {
    const vendorRes = await getCompanyVendors();
    const clientRes = await getCompanyCustomers();

    setVendors(vendorRes || []);
    setClients(clientRes || []);
  };

  useEffect(() => {
    getClientsAndVendors();
  }, []);

  useEffect(() => {
    if (!newDoc?.project?.name) {
      const func = async () => {
        const res = await getProject({ plantId });
        setNewDoc({ ...newDoc, project: { ...res, rev: 0 } });
      };
      func();
    }

    const getDocTransmittals = async () => {
      const res = await getAllDocTransmittalsProject({ plantId });
      setAllDocTransmittals(res);
    };
    getDocTransmittals();
  }, [tab, openDocTransmittalRegister]);

  const handleChangeTab = (_, newValue) => {
    setTab(newValue);
  };
  const onCLickAddNew = () => {
    setTab("form");
  };

  const onCLickAddNewRev = ({ row }) => {
    setTab("form");
    console.log("row", row);
  };

  const onSubmit = async () => {
    const formData = new FormData();
    console.log("formData submt", { ...newDoc, selectedDocuments });
    for (let i = 0; i < files.length; i++) {
      formData.append("docs", files[i]);
    }

    formData.append("data", JSON.stringify({ ...newDoc, selectedDocuments }));

    const res = await addNewDocTransmittal(formData);
    console.log("After saving doc transmittal:", res);
    return res;
  };

  return (
    <DocTransmittalContext.Provider
      value={{
        newDoc,
        setNewDoc,
        files,
        setFiles,

        vendors,
        clients,

        allDocTransmittals,

        tab,
        handleChangeTab,
        onCLickAddNew,
        onCLickAddNewRev,

        onSubmit,
        openDocTransmittalRegister,
        handleOpenDocTransmittalRegister,
        handleCloseDocTransmittalRegister,
      }}
    >
      <DocTransmittalRegister />
      {children}
    </DocTransmittalContext.Provider>
  );
};
